import React, { useEffect } from "react"
import { CSSTransition } from "react-transition-group"
import SwitchTransition from "react-transition-group/SwitchTransition"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { Labels } from "../../../util/Translations"
import { useAppDispatch, useAppSelector } from "../../../hooks"

import {
    createBookmark,
    removeBookmark,
    fetchBookmark,
    setBookmarkResource,
} from "../slice"
import { GlobalState } from "../../../store"
import { TDataAPIBookmarkResourceType } from "../../../models"

interface IBookmarkButtonProp {
    bookmarkButtonId: string
    resourceType: TDataAPIBookmarkResourceType
    resourceId: number
}

type Props = IBookmarkButtonProp

const BookmarkButton: React.FC<Props> = ({
    bookmarkButtonId,
    resourceId,
    resourceType,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const bookmarkButton = useAppSelector(
        (store: GlobalState) => store.dataAPIBookmark,
    )

    const { AddBookmark, RemoveBookmark } = Labels

    useEffect(() => {
        if (!bookmarkButton.isLoading) {
            dispatch(
                setBookmarkResource({
                    isLoading: bookmarkButton.isLoading,
                    resourceType: resourceType,
                    resourceId: resourceId,
                }),
            )
            dispatch(fetchBookmark())
        }
    }, [resourceId])

    const caption = !!bookmarkButton.bookmarkId
        ? Symbols.BookmarkFilled
        : Symbols.BookmarkEmpty

    const title = bookmarkButton.bookmarkId ? RemoveBookmark : AddBookmark

    return (
        <>
            <SwitchTransition>
                <CSSTransition
                    key={
                        !!bookmarkButton.bookmarkId
                            ? "bookmarked"
                            : "not_bookmarked"
                    }
                    in={true}
                    timeout={150}
                    classNames="bookmark-fade"
                >
                    <Action
                        id={bookmarkButtonId}
                        title={title}
                        isLoading={bookmarkButton.isLoading}
                        data-ft-is-bookmarked={!!bookmarkButton.bookmarkId}
                        actionType={ActionType.icon}
                        onClick={(): void => {
                            bookmarkButton.bookmarkId
                                ? dispatch(removeBookmark())
                                : dispatch(createBookmark())
                        }}
                    >
                        {caption}
                    </Action>
                </CSSTransition>
            </SwitchTransition>
        </>
    )
}
export default BookmarkButton
